import type { ReactElement } from "react";
import { CmtsScheduledJobsContainer } from "../../core/containers/domain/governanceRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsScheduledJobsContainer runtime={props.runtime} />;
}

export default Component;
